module.exports = __webpack_public_path__ + "img/kuangjiao_xc1.3965fcbf.jpg";